export const MAX_CART_LINE_ITEMS = 100;
export const MAX_CART_ITEM_QUANTITY = 10000;

export function getCartItemUnitPriceHT(item: any): number {
  const basePrice = Number(item?.product?.priceHT);
  if (!Number.isFinite(basePrice) || basePrice < 0) {
    const storedPrice = Number(item?.priceHT ?? item?.price);
    return Number.isFinite(storedPrice) && storedPrice >= 0 ? storedPrice : 0;
  }

  const rawVolumeDiscounts = item?.product?.volumeDiscounts;
  let volumeDiscounts = rawVolumeDiscounts;
  if (typeof rawVolumeDiscounts === 'string') {
    try {
      volumeDiscounts = JSON.parse(rawVolumeDiscounts);
    } catch {
      volumeDiscounts = [];
    }
  }
  const quantity = Number(item?.quantity) || 0;
  const volumeDiscount = Array.isArray(volumeDiscounts)
    ? volumeDiscounts
      .filter((discount: any) => {
        const minimumQuantity = Number(discount?.minQuantity);
        const discountPercent = Number(discount?.discountPercent);
        return (
          Number.isFinite(minimumQuantity) &&
          minimumQuantity <= quantity &&
          Number.isFinite(discountPercent) &&
          discountPercent >= 0 &&
          discountPercent <= 100
        );
      })
      .sort(
        (left: any, right: any) =>
          Number(left.minQuantity) - Number(right.minQuantity),
      )
      .pop()
    : null;
  const productDiscount = Number(item?.product?.discountRate);
  const discountRate = volumeDiscount
    ? Number(volumeDiscount.discountPercent)
    : Number.isFinite(productDiscount)
      ? productDiscount
      : 0;

  if (discountRate < 0 || discountRate > 100) {
    return basePrice;
  }

  return Number((basePrice * (1 - discountRate / 100)).toFixed(4));
}

export function getCartItemTaxEur(item: any): number {
  const quantity = Number(item?.quantity) || 0;
  const taxRate = Number(item?.product?.tvaRate) || 0;
  const downloadsTotal = Array.isArray(item?.selectedDownloads)
    ? item.selectedDownloads.reduce(
      (total: number, download: any) =>
        total + (Number.parseFloat(download?.price) || 0),
      0,
    )
    : 0;

  return (
    (getCartItemUnitPriceHT(item) * quantity + downloadsTotal) *
    (taxRate / 100)
  );
}

export function getCartTaxEur(cart: any[] = []): number {
  return cart.reduce(
    (total, item) => total + getCartItemTaxEur(item),
    0,
  );
}

export function getCartItemMinimumQuantity(item: any): number {
  const primaryUnit = item?.product?.unit_sales || item?.product?.unit_product;
  const minimumQuantity = Number(primaryUnit?.minimal_quantity);
  if (Number.isInteger(minimumQuantity) && minimumQuantity > 0) {
    return minimumQuantity;
  }

  const productMinimumQuantity = Number(item?.product?.minimal_quantity);
  return Number.isInteger(productMinimumQuantity) && productMinimumQuantity > 0
    ? productMinimumQuantity
    : 1;
}

export function getCartItemMaximumQuantity(_item?: any): number {
  return MAX_CART_ITEM_QUANTITY;
}

export function getCartItemQuantityError(item: any): string | null {
  const quantity = Number(item?.quantity);
  const minimumQuantity = getCartItemMinimumQuantity(item);
  const maximumQuantity = getCartItemMaximumQuantity(item);

  if (!Number.isInteger(quantity) || quantity <= 0) {
    return 'Ilość musi być dodatnią liczbą całkowitą.';
  }
  if (quantity < minimumQuantity || quantity % minimumQuantity !== 0) {
    return `Ilość musi wynosić co najmniej ${minimumQuantity} szt. i być jej wielokrotnością.`;
  }
  if (quantity > MAX_CART_ITEM_QUANTITY) {
    return `Ilość nie może przekraczać ${MAX_CART_ITEM_QUANTITY} szt.`;
  }
  if (quantity > maximumQuantity) {
    return `Obecnie dostępnych jest tylko ${maximumQuantity} szt.`;
  }

  return null;
}
